module.exports = __webpack_public_path__ + "img/blog-48.ed82e481.jpg";